import React, {useState} from 'react'
import globals from '../../globals.json';

export default function SingleSelect(props) {
  //instant feedback binary choice, could technically have more than 2 options.
  const [answer, setAnswer] = useState(-1);
  const selectAnswer = (i) => {
    if (answer === -1) setAnswer(i);
    if (props.setAnswered) props.setAnswered(1);
  }
  return (
    <div className={`SingleSelect ${props.data.class}`}>
      <div className="setup" dangerouslySetInnerHTML={{__html: props.data.setup}}></div>
      {props.data.options.map((el, i) => {
        return <div className={`option option-${i} ${answer === -1 ? 'active' : ''} ${answer === i ? 'selected' : ''}`}
                    onClick={() => selectAnswer(i)}
                    key={`option-${i}`}
                    dangerouslySetInnerHTML={{__html: el.text}}></div>
      })}

      {(answer !== -1) &&
      <div className="feedback" dangerouslySetInnerHTML={{__html: props.data.options[answer].feedback}}></div>}
      {(answer !== -1) && <div className="next-button" onClick={props.onComplete}>{globals.nextButtonText}</div>}

    </div>
  )
}
